var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.00 0.00 32.00 30.00",
    width: 32,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B595",
    d: " M 17.90 0.00 Q 25.69 1.05 29.26 6.99 Q 32.40 12.21 31.42 17.37 Q 29.38 28.09 18.01 30.00 L 15.33 30.00 Q 6.03 28.69 2.67 20.53 Q 0.56 15.44 2.61 9.62 Q 5.47 1.46 15.23 0.00 L 17.90 0.00 Z M 18.04 11.35 Q 17.88 11.91 16.57 13.19 C 15.38 14.34 14.91 15.25 15.09 16.81 Q 15.17 17.52 15.88 17.52 L 16.60 17.52 Q 17.37 17.52 17.37 16.74 L 17.37 15.80 Q 17.37 15.28 17.76 14.94 Q 20.12 12.84 20.33 12.05 Q 21.21 8.71 18.02 7.77 Q 14.58 6.76 12.71 9.43 Q 12.16 10.21 13.09 11.03 Q 13.45 11.35 13.99 11.04 C 14.66 10.67 15.17 9.86 16.09 9.78 Q 17.13 9.68 17.90 10.42 Q 18.22 10.73 18.04 11.35 Z M 17.64 20.50 A 1.48 1.48 0.0 0 0 16.16 19.02 A 1.48 1.48 0.0 0 0 14.68 20.50 A 1.48 1.48 0.0 0 0 16.16 21.98 A 1.48 1.48 0.0 0 0 17.64 20.50 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenQuestion);
export default __webpack_public_path__ + "static/media/green-question.72029516c5abd545be1379510b3d3ce3.svg";
export { ForwardRef as ReactComponent };